import { matchRoutes, useLocation } from "react-router-dom"

const routes = [
  { path: 'home' },
  { path: 'posts/:id' },
  { path: 'profiles/:id' },
  { path: 'grid' },
  { path: 'map' },
  { path: 'notifications' },
  { path: 'conversations' },
  { path: 'search' },
  { path: 'about' },
  { path: 'settings' },
  { path: 'settings/manage_subscription' },
  { path: 'landing' },
  { path: 'login' },
  { path: 'password_reset' },
  { path: 'subscription' },
]

const useCurrentPath = () => {
  const location = useLocation()
  const [match] = matchRoutes(routes, location) || [null]
  // default path to home if path not found
  const route = match?.route || { path: 'map' }
  return route.path
}

export default useCurrentPath
